<template>
  <div>
    <header class="header">
      <h1 v-if="name" class="header__title">{{name}}</h1>
    </header>

    <b-form-group
      v-for="(attr, name) in attrs"
      :key="name"
      :label="attr.label"
      label-size="sm"
      horizontal
      class="text-sm-right"
    >
      <b-form-select v-if="attr.type === 'select'" size="sm" v-model="attr.value">
        <option :value="option.value" v-for="option in attr.options" :key="option.label">{{option.label}}</option>
      </b-form-select>

      <template v-else-if="attr.type === 'file'">
        <b-form-file size="sm" @change="fileChanged($event, attr)"></b-form-file>
        <a :href="attr.value" target="_blank" class="small">{{attr.value}}</a>
      </template>

      <template v-else>
        <b-form-input type="text" size="sm" v-model="attr.value"></b-form-input>
      </template>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: [
    'name',
    'attributes'
  ],

  data() {
    return {
      attrs: this.attributes
    }
  },

  watch: {
    attrs: {
      handler(val) {
        this.$emit('changed', val)
      },
      deep: true
    }
  },

  methods: {
    // TODO: dry this out with the uploader
    fileChanged(e, attr) {
      let files = e.target.files

      if (files.length > 0) {
        // only upload the first file
        let file = files[0]

        fetch(`${process.env.VUE_APP_UPLOADER_API_URL}?filename=${file.name}&filetype=${file.type}`)
          .then((res) => res.json())
          .then((json) => {
            return Promise.all([fetch(json.signedRequest, {
              method: 'PUT',
              body: file
            }), json.url])
          })
          .then(([res, url]) => {
            this.$set(attr, 'value', `url(${url})`)
            return res
          })
          .catch(err => console.error(err))
      }
    }
  }
}
</script>

<style scoped>
  .header {
    padding: 10px;
  }

  .header__title {
    font-size: 1rem;
    font-weight: bold;
  }
</style>
